export const getDomainExtension = (): string => {
    // const url = window.document.domain - deprecated
    // const testdomain = "www.book.park-depot.de"
    // const domain = 'at'
    // const domain = 'ch'

    const url = new URL(window.location.href)
    // if url contains localhost, return 'de'
    if (url.hostname.includes('localhost')) {
        return 'de'
    }
    const domainParts = url.hostname.split('.')

    return domainParts[domainParts.length - 1]
}

export const getLanguageBasedOnDomain = (): string => {
    const domain = getDomainExtension()
    switch (domain) {
        case 'com':
            return 'en'
        case 'ch':
            return 'de-CH'
        case 'at':
            return 'de'
        default:
            return domain
    }
}
